import { H5 } from 'foundations-components/transitional/components/H5';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import ApprovalHeadingI18n from '../i18n/ApprovalHeadingI18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalHeading() {
  const {
    noApprovalData
  } = useApprovalConditions();
  if (noApprovalData) {
    return null;
  }
  return /*#__PURE__*/_jsx(H5, {
    "data-test-id": "approval-heading",
    marginBlockEnd: "0",
    children: /*#__PURE__*/_jsx(ApprovalHeadingI18n, {})
  });
}
export default ApprovalHeading;